import { lazier } from '@shared/components';

export const FeedbackPage = lazier(() => import('./FeedbackPage'));
